import type { DataTableColumnMeta } from "./dataTableFeatures";

export function getColumnTrack(meta: DataTableColumnMeta | undefined): string {
  const { width, minWidth, maxWidth } = meta ?? {};

  if (!minWidth && !maxWidth) {
    return width ?? "1fr";
  }

  return `minmax(${minWidth ?? width ?? "auto"}, ${maxWidth ?? width ?? "1fr"})`;
}
